import {Component, OnInit, Renderer2} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {Location} from '@angular/common';
import { PreviousUrlService } from './shared/services/previous-url.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']

})
export class AppComponent implements OnInit {

  constructor(private router: Router, private location: Location, private previousUrlService: PreviousUrlService, private renderer: Renderer2) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && (this.router.routerState.snapshot.url.includes('(') || this.router.routerState.snapshot.url.includes(')'))) {
        this.location.go(this.router.routerState.snapshot.url.replace(/\(/g, '[').replace(/\)/g, ']'));
      }
    });
  }
  ngOnInit() {
    this.previousUrlService.titleChanges.subscribe(surveyTitle => {
      if (this.router.url === '/surveys' && surveyTitle === 'Survey List') {
        this.renderer.addClass(document.body, 'survey-dashboard');
      } else {
        this.renderer.removeClass(document.body, 'survey-dashboard');
      }
    });
  }



  title = 'app';
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts